import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// import mui icons
import FilterListIcon from "@mui/icons-material/FilterList";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControlLabel from "@mui/material/FormControlLabel";

import { useSelector, useDispatch } from "react-redux";

import { loadClaimsAnalysisSelectedTagsFilterState } from "../../store/features/claimsAnalysisSlice";

function ClaimsTerritoryFilter({
    claimsTerritoryTags = [],
    page = null,
    // fetchSelectedTags = () => {
    //     return [];
    // },
}) {
    const dispatch = useDispatch();
    const claimsTerritorySelectedTags = useSelector((state) => state.claimsAnalysisStore.claimsAnalysisSelectedTagsFilter) || [];

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);

    useEffect(() => {
        assignDefaultData();
    }, [page]);

    const handleOpen = () => {
        setIsFilterOpen(!isFilterOpen);
        assignDefaultData();
    };

    const handleClickAway = () => {
        setIsFilterOpen(false);
        assignDefaultData();
    };

    const assignDefaultData = () => {
        if (page === "claimsAnalysis") {
            setSelectedTags(JSON.parse(JSON.stringify(claimsTerritorySelectedTags)));
        }
    };

    const handleOnChange = (event, label, type = "individualCheck") => {
        let datum = [...selectedTags];

        if (type === "individualCheck") {
            if (label) {
                if (event.target.checked) {
                    datum = [...datum, label];
                } else {
                    const index = datum.indexOf(label);
                    if (index !== -1) {
                        datum.splice(index, 1);
                    }
                }
            }
        } else if (type === "allCheck") {
            if (event.target.checked) {
                datum = [...claimsTerritoryTags];
            } else {
                datum = [];
            }
        }
        setSelectedTags([...datum]);
    };

    const handleApply = async () => {
        if (page === "claimsAnalysis") {
            await dispatch(loadClaimsAnalysisSelectedTagsFilterState(selectedTags));
        }
        // fetchSelectedTags(selectedTags);
        setIsFilterOpen(false);
    };

    return (
        <>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={handleClickAway}
            >
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <button
                            style={{
                                border: "none",
                                padding: "2px 10px",
                                borderRadius: 5,
                                fontSize: "12px",
                            }}
                            className="color-blue"
                            onClick={handleOpen}
                        >
                            <FilterListIcon
                                style={{
                                    fontSize: 18,
                                }}
                            />

                            <span>Claims Territory Filter</span>
                        </button>
                    </div>
                    {isFilterOpen && (
                        <Box
                            role="presentation"
                            sx={{
                                position: "relative",
                                top: 10,
                                right: 0,
                                left: "50%",
                                transform: "translate(-50%, 0%)",
                                border: "1px solid #dee2e6",
                                borderRadius: "10px",
                                bgcolor: "#F7F7FF",
                                width: "250px",
                                padding: "10px",
                                zIndex: 1,
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    borderBottom: "1px solid grey",
                                }}
                            >
                                <FormControlLabel
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: 12,
                                            margin: "5px 0px",
                                            padding: 0,
                                            display: "block",
                                            paddingLeft: 1,
                                        },
                                    }}
                                    style={{
                                        display: "flex",
                                        margin: "0px 0px 0px 0px",
                                        padding: "0px 8px",
                                        textAlign: "left",
                                    }}
                                    control={
                                        <Checkbox
                                            sx={{
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: 18,
                                                    padding: 0,
                                                },
                                            }}
                                            style={{
                                                padding: 5,
                                            }}
                                            color="primary"
                                            value="Select All"
                                            onChange={(event) => handleOnChange(event, null, "allCheck")}
                                            checked={selectedTags.length === claimsTerritoryTags.length ? true : false}
                                        />
                                    }
                                    label="Select All"
                                />
                            </div>
                            <div
                                style={{
                                    marginTop: 5,
                                    marginBottom: 5,
                                }}
                            >
                                {claimsTerritoryTags.map((label, i) => {
                                    return (
                                        <div
                                            key={i}
                                            style={{
                                                paddingLeft: 25,
                                            }}
                                        >
                                            <FormControlLabel
                                                sx={{
                                                    "& .MuiTypography-root": {
                                                        fontSize: 12,
                                                        margin: "5px 0px",
                                                        padding: 0,
                                                        display: "block",
                                                        paddingLeft: 1,
                                                    },
                                                }}
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            "& .MuiSvgIcon-root": {
                                                                fontSize: 18,
                                                                padding: 0,
                                                            },
                                                        }}
                                                        style={{
                                                            padding: 5,
                                                        }}
                                                        color="primary"
                                                        onChange={(event) => handleOnChange(event, label, "individualCheck")}
                                                        value={label}
                                                        checked={selectedTags.includes(label) ? true : false}
                                                    />
                                                }
                                                label={label}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <Button
                                    size="small"
                                    className="custom-btn custom-btn-outlined color-blue"
                                    variant="outlined"
                                    onClick={handleApply}
                                >
                                    Apply
                                </Button>
                            </div>
                        </Box>
                    )}
                </div>
            </ClickAwayListener>
        </>
    );
}

// Typechecking props for the OverallKpi
ClaimsTerritoryFilter.propTypes = {
    claimsTerritoryTags: PropTypes.array,
    page: PropTypes.string,
    // fetchSelectedTags: PropTypes.func,
};

export default ClaimsTerritoryFilter;
